<template>
  <div>
    <br /><br /><br />
    <h1>{{ name }} są obecnie ukryte!</h1>
    <small>Zostaną udostępnione już wkrótce</small>
    <br /><br />
    <router-link to="/" class="btn">Wróć na stronę główną</router-link>
  </div>
</template>

<script>
export default {
  name: 'tab-locked',
  props: {
    name: String,
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

h1 {
  color: $orange;
  font-size: 1.6em;
}
</style>
